import React, { useState } from "react";
import useReservedFullHooks from "./useReserved_FullHooks";
import ReserveDeputyForm from "./Reserve_DeputyForm";
import { useNavigate } from "react-router-dom"; // Import for back button

const DeputyList = () => {
  const {
    staffList,
    formData,
    setFormData,
    submitForm,
    editStaff,
    setEditStaff,
    handleEdit,
    fetchStaff,
    resetForm,
  } = useReservedFullHooks();

  const [selectedSkills, setSelectedSkills] = useState([]);
const [showSkillsModal, setShowSkillsModal] = useState(false);

const openSkillsModal = (skills) => {
  setSelectedSkills(skills);
  setShowSkillsModal(true);
};

const closeSkillsModal = () => {
  setSelectedSkills([]);
  setShowSkillsModal(false);
};


  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate(); // Hook for back navigation

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = staffList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(staffList.length / itemsPerPage);

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  const openEditModal = (staff) => {
    handleEdit(staff);
    setTimeout(() => setShowModal(true), 0);
  };

  const closeModal = () => {
    setShowModal(false);
    resetForm();
  };

  const onSuccess = () => {
    fetchStaff();
    closeModal();
  };

  return (
    <div className="p-6 bg-gray-200 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Reserved Deputy Staff</h2>
        <div className="flex gap-3">
          <button
            onClick={() => navigate(-1)}
            className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded shadow"
          >
            ← Back
          </button>
          <button
            onClick={openAddModal}
            className="bg-blue-600 text-white px-5 py-2 rounded-lg shadow hover:bg-blue-700"
          >
            + Add Deputy
          </button>
        </div>
      </div>

      {/* Table View */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border shadow-md rounded-lg overflow-hidden">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="px-4 py-2 border">S.No</th>
              <th className="px-4 py-2 border">Photo</th>
              <th className="px-4 py-2 border">Name</th>
              <th className="px-4 py-2 border">Gender</th>
              <th className="px-4 py-2 border">Designation</th>
              <th className="px-4 py-2 border">Department</th>
              <th className="px-4 py-2 border">Contact</th>
              <th className="px-4 py-2 border">Address</th>
              <th className="px-4 py-2 border">Community</th>
              <th className="px-4 py-2 border">Availability</th>
              <th className="px-4 py-2 border">Skills</th>
              <th className="px-4 py-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length === 0 ? (
              <tr>
                <td colSpan="12" className="text-center py-4 text-gray-500">
                  No staff found.
                </td>
              </tr>
            ) : (
              currentItems.map((staff, index) => (
                <tr key={staff.StaffId} className="text-center hover:bg-gray-50">
                  <td className="border px-2 py-2 font-medium">
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td className="border px-2 py-2">
                    <img
                      src={staff.StaffImage || "https://via.placeholder.com/50"}
                      alt={staff.FullName}
                      className="w-10 h-10 object-cover rounded-full mx-auto"
                    />
                  </td>
                  <td className="border px-4 py-2">{staff.FullName}</td>
                  <td className="border px-4 py-2">{staff.Gender}</td>
                  <td className="border px-4 py-2">{staff.Designation}</td>
                  <td className="border px-4 py-2">{staff.Department}</td>
                  <td className="border px-4 py-2">{staff.ContactNo}</td>
                  <td className="border px-4 py-2">{staff.Address}</td>
                  <td className="border px-4 py-2">{staff.CommunityName}</td>
                  <td className="border px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        staff.isAvailable
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {staff.isAvailable ? "Available" : "Unavailable"}
                    </span>
                  </td>
                 <td className="border px-4 py-2">
  <button
    onClick={() => openSkillsModal(staff.Skills || [])}
    className="text-blue-600 underline text-sm hover:text-blue-800"
  >
    View Skills
  </button>
</td>

                  <td className="border px-4 py-2">
                    <button
                      onClick={() => openEditModal(staff)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      {staffList.length > itemsPerPage && (
        <div className="flex justify-center items-center mt-4">
          <button
            onClick={() => setCurrentPage((prev) => prev - 1)}
            disabled={currentPage === 1}
            className="bg-gray-300 px-4 py-2 rounded disabled:opacity-50"
          >
            ← Prev
          </button>

          <div className="space-x-2">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`px-3 py-1 rounded ${
                  currentPage === i + 1
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-800"
                }`}
              >
                {i + 1}
              </button>
            ))}
          </div>

          <button
            onClick={() => setCurrentPage((prev) => prev + 1)}
            disabled={currentPage === totalPages}
            className="bg-gray-300 px-4 py-2 rounded disabled:opacity-50"
          >
            Next →
          </button>
        </div>
      )}


      {showSkillsModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md relative">
      <button
        onClick={closeSkillsModal}
        className="absolute top-2 right-2 text-gray-500 hover:text-black"
      >
        ✕
      </button>
      <h3 className="text-lg font-semibold mb-4">Deputy Skills</h3>
      {selectedSkills.length > 0 ? (
        <ul className="list-disc pl-5 space-y-1">
          {selectedSkills.map((skill, idx) => (
            <li key={skill.SkillId || idx} className="text-gray-700">
              {skill.SkillName}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500">No skills found for this staff.</p>
      )}
    </div>
  </div>
)}


      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-xl w-full max-w-xl relative">
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-black"
              onClick={closeModal}
            >
              ✕
            </button>
            <h3 className="text-lg font-semibold mb-4">
              {editStaff ? "Edit Deputy" : "Add Deputy"}
            </h3>
            <ReserveDeputyForm
              formData={formData}
              setFormData={setFormData}
              submitForm={submitForm}
              onSuccess={onSuccess}
              editStaff={editStaff}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DeputyList;
